import React from 'react';
import PropTypes from 'prop-types';

const LineTitle = (props) => {
  const { text, size, className, children } = props;

  return (
    <div className={`lineTitle ${className} ${size}`}>
      {text && <span>{text}</span>}
      {children}
    </div>
  );

};

LineTitle.defaultProps = {
  text: '',
  size: 'md',
  className: '',
};

LineTitle.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default LineTitle;
